import React from 'react'
import { shape } from 'prop-types'
import CMSRenderer from 'components/cms/CMSModules'
import './footer.scss'
import MiniFooter from './MiniFooter'

const Footer = (props) => {
  const { pageContent: data, ...rest } = props
  return (
    <footer>
      {data ? <CMSRenderer {...rest} contents={data.footerContent} /> : null}
      <MiniFooter />
    </footer>
  )
}

Footer.propTypes = {
  pageContent: shape({}).isRequired,
}

export default Footer



// WEBPACK FOOTER //
// ./components/footer/index.js